/*
 * $Id:: ActionsButton.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useState } from 'react';

import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { getLocale } from '../../../../../providers';

import { t } from '../../../../../providers';

const ActionsButton = ({ account, edit, setStatus, globals, className, appId = '' }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [menuIsOpen, setMenuIsOpen] = useState(false);

    const handleClick = (event) => {
        setMenuIsOpen(true);
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setMenuIsOpen(false);
        setAnchorEl(null);
    };

    const editAccount = (event) => {
        event.preventDefault();
        const url = `${globals.ipo['fo.url']}/ChildAccounts/?child=${account.username}&lang=${getLocale()}`;
        window.open(url, '_blank');
    };

    const setAccountStatus = (event) => {
        event.preventDefault();
        setStatus(account);
    };

    return (
        <>
            <IconButton
                id={`options-btn-${appId}`}
                className={className}
                disableFocusRipple
                aria-label={t('open.list.option')}
                aria-expanded={menuIsOpen}
                aria-haspopup="listbox"
                onClick={handleClick}
                aria-controls={`action-btn-menu-${appId}`}>
                <MoreVertIcon aria-hidden="true" focusable="false" />
            </IconButton>
            <Menu
                MenuProp={{ role: 'listbox' }}
                id="child-account-options-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                MenuListProps={{
                    id: `action-btn-menu-${appId}`,
                    'aria-labelledby': `options-btn-${appId}`,
                    style: { display: menuIsOpen ? 'block' : 'none' },
                }}>
                <MenuItem onClick={editAccount} role="option">
                    {t('edit')}
                </MenuItem>
                <MenuItem onClick={setAccountStatus} role="option">
                    {t(account.enabled ? 'deactivate' : 'activate')}
                </MenuItem>
            </Menu>
        </>
    );
};

export default ActionsButton;
